// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ActiveStatus } from './active-status';
import { ApprovalTreeUserGroup } from './approval-tree-user-group';
import { ProgramUserGroupBudget } from './program-user-group-budget';
import { ProgramUserGroupExclusion } from './program-user-group-exclusion';
import { ProgramUserGroupMap } from './program-user-group-map';
import { ProximityUser } from './proximity-user';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramUserGroup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.account];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK consolidatedByUser */
  consolidatedByUserId?: string;
  /** Guid FK consolidatedIntoPug */
  consolidatedIntoPugId?: string;
  /** DateTime */
  consolidatedOn?: Date;
  /** String(120) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK programUserGroupId */
  approvalTreeUserGroups!: ApprovalTreeUserGroup[];
  /** FK consolidatedByUserId */
  consolidatedByUser!: ProximityUser;
  /** FK consolidatedIntoPugId */
  consolidatedIntoPug!: ProgramUserGroup;
  /** Inv FK programUserGroupId */
  programUserGroupBudgets!: ProgramUserGroupBudget[];
  /** Inv FK programUserGroupId */
  programUserGroupExclusions!: ProgramUserGroupExclusion[];
  /** Inv FK programUserGroupId */
  programUserGroupMaps!: ProgramUserGroupMap[];
}

